// extracted by mini-css-extract-plugin
export default {"container":"i5-z"};